import { MdAdminPanelSettings, MdPerson } from "react-icons/md";

export const ROLE_OPTIONS = [
  {
    value: "AGENT",
    label: "Agent",
    desc: "Handles customer transactions.",
    icon: MdPerson,
    accent: "primary",
  },
  {
    value: "ADMIN",
    label: "Admin",
    desc: "Manages business & users.",
    icon: MdAdminPanelSettings,
    accent: "warning",
  },
];
